<template lang="pug">
  .row.report-template(v-if="!editing" :data-id="template.id")
    .col-md-9.contents
      .row
        strong.col-md-12.title(v-html="templateName(template)")
      .row(v-if="isExpanded")
        .col-md-11.push-md-1.field.intro
          strong Day Of Week
          p {{ template.dow }}
        .col-md-11.push-md-1.field.intro
          strong Time Of Day
          p {{ template.tod }}
        .col-md-11.push-md-1.field.intro
          strong Intro:
          p {{ template.intro }}
        .col-md-11.push-md-1.field.outro
          strong Outro:
          p {{ template.close }}
        .col-md-10.push-md-2.images
          strong Images:
          .image(v-for="image in images")
            strong.row.col-md-12.title {{ image.title }}
            .row.col-md-12.text {{ image.text }}
            .row.timeout(v-if="image.timeout")
              strong.col-md-2 Timeout:
              span.col-md-2 {{ image.timeout }}
            .row.width(v-if="image.width")
              strong.col-md-2 Width:
              span.col-md-2 {{ image.width }}
            .row.height(v-if="image.height")
              strong.col-md-2 Height:
              span.col-md-2 {{ image.height }}
    .col-md-3.actions
      b-button(@click.stop.prevent="onToggleExpand" size="sm")
        span(v-if="!isExpanded") More
        span(v-if="isExpanded") Less
      b-button(@click.stop.prevent="onEdit" size="sm") Edit
      b-button(@click.stop.prevent="onCopy" size="sm") Copy
      b-button(@click.stop.prevent="onDelete" size="sm" variant="danger") Delete
  report-template-form(v-else :template="template" @save="editing = false" @cancel="editing = false")
</template>

<script>
import reportTemplateForm from '@/components/report-template-form.vue'
import { mapActions } from 'vuex'
import extend from 'extend'

export default {
  name: 'report-template',
  props: {
    template: {},
    isEditing: {
      default: false,
      type: Boolean
    }
  },
  components: { reportTemplateForm },
  computed: {
    images () {
      return this.template.data.images
    }
  },
  data () {
    return {
      editing: this.isEditing,
      isExpanded: false
    }
  },
  methods: {
    ...mapActions(['addReportTemplate', 'deleteReportTemplate']),
    onEdit () {
      this.editing = true
    },
    templateName (template) {
      return `<strong>${template.id}</strong> | <span>${template.name}</span> | <span>${template.name_short}</span>`
    },
    onCopy () {
      var copy = extend({}, this.template)
      delete copy.id
      copy.name = `${copy.name} - Copy`
      copy.name_short = `${copy.name_short}_copy`
      this.addReportTemplate(copy)
    },
    onDelete () {
      this.deleteReportTemplate(this.template)
    },
    onToggleExpand () {
      this.isExpanded = !this.isExpanded
    }
  }
}

</script>

<style lang="stylus" scoped>

.report-template {
  margin-top: .5em
  margin-bottom: .5em

  header {
    font-weight: bold
  }

  .actions {
    text-align: right
    button {
      margin-left: .5em
    }
  }

  .form-control {
    display: inline-block
  }

  .images {
    margin-top: .5em

    .image {
      margin-bottom: 2em
    }

    .url {
      color: gray
    }

    header {
      font-weight: bold
    }
  }
}

</style>



// WEBPACK FOOTER //
// report-template.vue?13200046